import React from 'react';

/** Renders a tile row with an optional full-width footer below its main action. */
function TileActionRow(props) {
  return (
    <div className={`sgpsTile__actionRow${props.footer ? ' sgpsTile__actionRow--with-footer' : ''}`}>
      <div className="sgpsTile__actionRow__main">
        <div className="sgpsTile__actionRow__label">
          {props.label}
        </div>
        <div className="sgpsTile__actionRow__description">
          {props.description}
        </div>
      </div>
      <div className="sgpsTile__actionRow__icon">
        {props.action}
      </div>
      {props.footer ? (
        <div className="sgpsTile__actionRow__footer">
          {props.footer}
        </div>
      ) : null}
    </div>
  );
}

export default TileActionRow;
